<script setup lang="ts">
const props = defineProps<{
  tag: string;
  selected?: boolean;
}>();

const emit = defineEmits<{
  (e: "onRemove"): void;
  (e: "update:is-dragging", isDragging: boolean): void;
}>();

function dragStartHandler(ev: DragEvent) {
  // Notify parent that drag has started
  emit("update:is-dragging", true);

  // Transfer the tag text
  ev.dataTransfer?.setData("text", props.tag);

  // Optional: transfer custom node data
  ev.dataTransfer?.setData(
    "node",
    JSON.stringify({
      type: "contenteditable",
      data: { label: props.tag },
    }),
  );

  if (ev.dataTransfer) {
    ev.dataTransfer.effectAllowed = "move";
  }

  // Hide the element ghost during drag
  setTimeout(() => {
    if (ev.target instanceof HTMLElement) {
      ev.target.style.visibility = "hidden";
    }
  }, 1);
}

function dragEndHandler(ev: DragEvent) {
  // Notify parent that drag has ended
  emit("update:is-dragging", false);

  // Restore visibility
  setTimeout(() => {
    if (ev.target instanceof HTMLElement) {
      ev.target.style.visibility = "";
    }
  }, 1);
}
</script>

<template>
  <div
    draggable="true"
    class="dragdrop relative flex h-7 max-w-[150px] w-fit flex-shrink-0 items-center justify-center gap-1 overflow-hidden rounded-2xl border border-secondary-accent bg-neutral px-3 py-1 text-secondary-accent shadow-md"
    :class="[
      selected && 'border-warning bg-warning-content text-primary-content',
    ]"
    @mousedown.stop
    @dragstart="dragStartHandler"
    @dragend="dragEndHandler"
  >
    <span
      class="block w-full truncate text-center"
      :class="selected ? 'text-primary-content' : 'text-accent'"
      :title="tag"
    >
      {{ tag }}
    </span>
    <span
      class="pointer-events-none absolute inset-y-0 right-0 w-6"
      :class="selected ? 'text-primary-content' : 'text-white'"
    ></span>
  </div>
</template>
